import { ViewCountKeyEnum } from '@ztechapps/common.contract'
import { useViewCount, type UseViewCountResult } from '@ztechapps/common.hook'

/**
 * Hook for managing Project view counts.
 * Automatically increments the view count when the project is viewed.
 *
 * @param projectId - The ID of the project
 * @returns viewCount, increment, loading, error
 *
 * @example
 * const { viewCount } = useProjectViewCount(projectId)
 */
export function useProjectViewCount(projectId: string): UseViewCountResult {
  return useViewCount({
    key: ViewCountKeyEnum.Project,
    value: projectId,
  })
}
